<form [formGroup]="form.formGroup">
  <div class="flex flex-col space-y-2">

    <div class="flex flex-row">
        <p-checkbox
          [pTooltip]="stringFullyCemented ? 'String is fully cemented' : ''"
          size="small"
          binary="true"
          [formControlName]="form.formControlNames.hasGasCap"
          (onChange)="hasGasCapChange()"
          inputId="hasGasCap"
        ></p-checkbox>
      <label class="ml-2" for="hasGasCap">Has Gas Cap</label>
    </div>

    <div class="flex flex-col">
      <label>Gas Cap Length</label>
      <app-validated-number-input
        [id]="'gasCapLength'"
        [control]="control('gasCapLength')"
        [value]="control('gasCapLength').value"
        [validation]="lengthValidation"
        [unit]="lengthUnit"
        [unitPrecisionOverrides]="{ 'ft': 2, 'm': 2 }"
      ></app-validated-number-input>
    </div>

    <div class="flex flex-col">
      <label>Gas Gradient</label>
      <app-validated-number-input
        [id]="'gasGradient'"
        [control]="control('gasGradient')"
        [value]="control('gasGradient').value"
        [validation]="gasGradientValidation"
        [unit]="gasGradientLabel"
        [unitPrecisionOverrides]="{ 'psi/ft': 4, 'kPa/m': 4, 'sg': 4, 'bar/m': 4 }"
      ></app-validated-number-input>
    </div>
    
  </div>
</form>